/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import { useState } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import { Link } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import CircularProgress from "@mui/material/CircularProgress";

// Images
import bgImage from "assets/images/bg-reset-cover.jpeg";

import { useForm } from "react-hook-form";
import { AuthAPI } from "api/AuthAPI";

function Cover() {

  const formSchema = yup.object().shape({
    email: yup.string().email('El email ingresado es incorrecto').required('El campo es requerido'),
  })

  const { handleSubmit, register, formState: { errors, isSubmitting }, } = useForm({ resolver: yupResolver(formSchema), });
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');

  const alertComponent = (
    <MDAlert color={alertColor}>
      <MDTypography variant="body2" color="white">
        {alertContent}
      </MDTypography>
    </MDAlert>
  );

  const onSubmit = (data) => {
    return AuthAPI.forgot(data)
      .then(response => {
        setAlertContent(response.message);
        setAlertColor('success');
        setAlert(true)
      }).catch(error => {
        setAlertContent(error.response.data.message);
        setAlertColor('error');
        setAlert(true)
      });
  }

  return (
    <CoverLayout>
      <MDBox mb={4} px={2}>
        {alert ? alertComponent : <></>}
      </MDBox>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Restaurar Contraseña
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Recibirás un e-mail en máximo 60 segundos
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
            <MDBox mb={4}>
              <MDInput type="email" label="Email" name="email" {...register("email")} fullWidth />
              {errors.email && <MDTypography variant="button" color="error">{errors.email.message}</MDTypography>}
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={isSubmitting}>
                {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Enviar'}
              </MDButton>
            </MDBox>
            <MDBox mt={1} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Iniciar Sesión
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
